import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import {selectCategory, fetchMoviesIfNeeded, invalidateCategory} from '../../actions'
import {
  selectCategory,
  fetchMoviesIfNeeded,
  fetchMenusIfNeeded,
  selectSection,
  fetchSectionsIfNeeded,
  selectMov2Filter,
  selectAZ,
  fetchMovs2FilterIfNeeded
} from "../../actions";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { MovieItem } from "./MovieItem";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";

export class MovieGalleryView extends React.Component {
  constructor(props) {
    super(props);
    this.toMap = this.toMap.bind(this);
    this.renderMovieItems = this.renderMovieItems.bind(this);
    this.onSectionClick = this.onSectionClick.bind(this);
    this.toggleAZorder = this.toggleAZorder.bind(this);
    this.onMovieFilterClick = this.onMovieFilterClick.bind(this);
    this.onClickTagLabel = this.onClickTagLabel.bind(this);
    this.gotoPage = this.gotoPage.bind(this);

    this.state = {
      curFilter: ""
    };
  }

  componentWillMount() {
    const { dispatch, match } = this.props;
    console.log("this.props", this.props);

    if (match.params.tagid) {
      dispatch(selectCategory("0"));
      dispatch(selectSection(match.params.tagid));
    } else {
      dispatch(selectCategory("0"));
    }
  }

  componentDidMount() {
    const { dispatch, selectedCategory, selectedScope, match } = this.props;
    let selCat = "0";
    if (match.params.tagid) {
      dispatch(selectCategory("0"));
      dispatch(selectSection(match.params.tagid));
      selCat = match.params.tagid;
    } else {
      dispatch(selectSection("SECÇÕES"));
      dispatch(selectCategory("0"));
    }

    dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope));
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(fetchSectionsIfNeeded("movies"));
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, selectedCategory, selectedScope } = nextProps;
    if (
      nextProps.selectedCategory !== this.props.selectedCategory ||
      nextProps.selectedScope !== this.props.selectedScope
    ) {
      dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope));
    }

    if (nextProps.selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
      dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope));
    }

    if (selectedScope !== "festa") {
      dispatch(fetchMovs2FilterIfNeeded());
    } else {
      dispatch(fetchSectionsIfNeeded("movies"));
    }
  }

  toMap(obj) {
    return Object.keys(obj).map(key => [key, obj[key]]);
  }

  renderMovieItems(movies) {
    const m = this.toMap(movies);
    return m.map((movie, i) => {
      <MovieItem
        type="movie"
        movie={movie}
        onClickTagLabel={this.onClickTagLabel}
        key={i}
      />;
    });
  }

  renderSections() {
    // let {sections} = this.props
    // const {selectedScope, selectedSection} = this.props

    const { selectedScope, selectedSection, selectedMov2Filter } = this.props;
    let sections, selectedSection_Movie;
    let dropdown_direction = null;

    if (selectedScope !== "festa") {
      sections = this.props.movs2filter;
      selectedSection_Movie = selectedMov2Filter.mov_name;

      dropdown_direction = true;
    } else {
      sections = this.props.sections;
      selectedSection_Movie = selectedSection;
    }

    return (
      <DropdownButton
        noCaret
        ref="mydropdown"
        className="section-list"
        pullRight={dropdown_direction}
        title={selectedSection_Movie}
        id="bg-justified-dropdown"
      >
        {sections.map((section, i) => {
          if (selectedScope !== "festa") {
            return (
              <MenuItem
                key={i}
                data-mid={section.id}
                data-tag={section.name}
                onClick={this.onSectionClick}
                eventKey={i}
              >
                {section.name}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem
                key={i}
                data-mid={section.id}
                data-tag={section.name}
                onClick={this.onSectionClick}
                eventKey={i}
              >
                {section.name}
              </MenuItem>
            );
          }
        })}
      </DropdownButton>
    );
  }

  onSectionClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.selectedScope !== "festa") {
      this.props.dispatch(
        selectMov2Filter(
          e.target.getAttribute("data-mid"),
          e.target.getAttribute("data-tag")
        )
      );
    } else {
      // this.props.dispatch(selectSection(e.target.getAttribute('data-tag')))
      const tagname = e.target.getAttribute("data-tag");

      if (tagname === "SECÇÕES") {
        this.props.dispatch(selectSection("SECÇÕES"));
        this.props.history.push("/filmes");
      } else {
        if (tagname === "Distribuição") {
          this.props.dispatch(
            fetchMoviesIfNeeded(this.props.selectedCategory, "distrib", true)
          );
        } else {
          this.props.dispatch(
            fetchMoviesIfNeeded(
              this.props.selectedCategory,
              this.props.selectedScope,
              true
            )
          );
        }

        this.setState({
          curFilter: tagname
        });

        const { dispatch, history } = this.props;
        setTimeout(function() {
          dispatch(selectSection(tagname));
          history.push(`/filmes/${tagname}`);
        }, 100);
      }
    }
  }

  onMovieFilterClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const tagname = e.target.getAttribute("data-tag");

    if (tagname === "Distribuição") {
      this.props.dispatch(
        fetchMoviesIfNeeded(this.props.selectedCategory, "distrib", true)
      );
    } else {
      this.props.dispatch(
        fetchMoviesIfNeeded(
          this.props.selectedCategory,
          this.props.selectedScope,
          true
        )
      );
    }

    this.setState({
      curFilter: tagname
    });
    const { dispatch } = this.props;

    setTimeout(function() {
      dispatch(selectSection(e.target.getAttribute("data-tag")));
    }, 100);
  }

  toggleAZorder(e) {
    e.preventDefault();
    e.stopPropagation();
    const orderByNameState = e.target.classList.contains("active-gallery")
      ? 0
      : 1;
    this.props.dispatch(selectAZ(orderByNameState));
  }

  renderMovies() {
    console.log("this state: ", this.state);

    const {
      movies,
      isFetching,
      selectedSection,
      selectedMov2Filter,
      movieIds
    } = this.props;
    console.log("movies: ", movies);
    let movie_list = [];

    if (movieIds) {
      movie_list = movieIds.map(id => {
        return movies[id];
      });
    }
    /*
    Object.keys(movies).map((id, i) => {
      movie_list.push(movies[id])
    })
    */
    let filt_movies = movie_list;

    if (
      typeof selectedSection !== "undefined" &&
      selectedSection !== "SECÇÕES"
    ) {
      filt_movies = movie_list.filter(movie => {
        return movie.name.toLowerCase() === selectedSection.toLowerCase();
      });
    } else if (selectedMov2Filter.mov_id !== "0") {
      filt_movies = movie_list.filter(movie => {
        return movie.id === parseInt(selectedMov2Filter.mov_id, 10);
      });
    }

    if (isFetching && filt_movies.length === 0) {
      return <h4 style={{ color: "#ccc" }}>A carregar conteúdos...</h4>;
    }

    if (!isFetching && filt_movies.length === 0) {
      let feedback = `Não existem filmes da categoria "${selectedSection}"`;
      if (selectedSection === "SECÇÕES") {
        feedback = "Não existem filmes";
      }
      return <h4 style={{ color: "#ccc" }}>{feedback}"</h4>;
    }

    if (this.props.selectedAZ === 1) {
      const orderedMovies = filt_movies.sort(this.compare);
      return orderedMovies.map((movie, i) => {
        return (
          <MovieItem
            type="movie"
            onClickTagLabel={this.onClickTagLabel}
            grid_size={4}
            movie={movie}
            key={i}
          />
        );
      });
    } else {
      return filt_movies.map((movie, i) => {
        return (
          <MovieItem
            type="movie"
            onClickTagLabel={this.onClickTagLabel}
            grid_size={4}
            movie={movie}
            key={i}
          />
        );
      });
    }
  }

  compare(a, b) {
    if (a.title < b.title) {
      return -1;
    } else if (a.title > b.title) {
      return 1;
    } else {
      return 0;
    }
  }

  onClickTagLabel(tagname) {
    if (tagname === "Distribuição") {
      this.props.dispatch(
        fetchMoviesIfNeeded(this.props.selectedCategory, "distrib", true)
      );
    } else {
      this.props.dispatch(
        fetchMoviesIfNeeded(
          this.props.selectedCategory,
          this.props.selectedScope,
          true
        )
      );
    }

    this.setState({
      curFilter: tagname
    });

    const { dispatch, history } = this.props;
    setTimeout(function() {
      dispatch(selectSection(tagname));
      history.push(`/filmes/${tagname}`);
    }, 100);
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  render() {
    const { isFetching, menus, selectedAZ, dispatch } = this.props;
    // const num_movies = Object.keys(movies).length
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const orderByNameClass = selectedAZ === 1 ? "active-gallery" : "";

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="movies-view" className="row m-gallery">
          <SearchView
            gotoPage={this.gotoPage}
            dispatch={dispatch}
            customStyle={"alignleft"}
          />
          <div className="col-md-12">
            <p className="section-title">FILMES</p>
          </div>
          <div className="grid-header">
            <p>Filtrar por</p>
            <div>
              {this.renderSections()}
              <button onClick={this.toggleAZorder} className={orderByNameClass}>
                FILMES A a Z
              </button>
            </div>
          </div>
          <div className="feedback">
            <div
              id="movie-list"
              className="col-xs-12 no-pad"
              style={{ opacity: isFetching ? 0.5 : 1 }}
            >
              {this.renderMovies()}
            </div>
          </div>
        </div>
        <FooterLinks bottom_menus={bottom_menus} />
        <FooterNote />
      </div>
    );
  }
}

MovieGalleryView.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  movies: PropTypes.object.isRequired,
  movieIds: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  lastUpdated: PropTypes.number,
  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedSection: PropTypes.string.isRequired,
  sections: PropTypes.array.isRequired,
  selectedMov2Filter: PropTypes.object.isRequired,
  movs2filter: PropTypes.array.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {
    selectedCategory,
    selectedScope,
    moviesByCategory,
    getMenus,
    getSections,
    getMovs2Filter,
    selectedSection,
    selectedMov2Filter,
    movieIds,
    selectedAZ
  } = state;
  const { isFetching, lastUpdated, items: movies } = moviesByCategory[
    selectedCategory
  ] || {
    isFetching: true,
    items: {}
  };

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingSections, items: sections } = getSections[
    `movies_${selectedScope}`
  ] || {
    isFetchingSections: true,
    items: []
  };

  const { isFetchingMov2Filter, items: movs2filter } = getMovs2Filter[
    "all"
  ] || {
    isFetchingMov2Filter: true,
    items: []
  };

  return {
    selectedScope,
    selectedCategory,
    movies,
    movieIds,
    isFetching,
    lastUpdated,
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedSection,
    selectedMov2Filter,
    sections,
    movs2filter,
    isFetchingSections,
    isFetchingMov2Filter,
    selectedAZ
  };
}

export default connect(mapStateToProps)(MovieGalleryView);



// WEBPACK FOOTER //
// ./src/views/MoviesView/MovieGalleryView.js